import {
	connectRouter,
	LocationChangeAction,
	RouterState,
} from 'connected-react-router';
import { History } from 'history';
import { Action, AnyAction, combineReducers, Dispatch } from 'redux';
import * as effects from 'redux-saga/effects';
import { Reducer } from 'typesafe-actions';
import { AppsManagementReducer } from './AppsManagement/Reducer';
import { AppsManagementSaga } from './AppsManagement/Saga';
import { IAppsManagementState } from './AppsManagement/Types';
import { I18NReducer } from './I18n/Reducer';
import { I18NSaga } from './I18n/Sagas';
import { I18NState } from './I18n/Types';
import { LayoutReducer } from './Layout/Reducer';
import { LayoutSaga } from './Layout/Sagas';
import { ILayoutState } from './Layout/Types';
import { NotificationBarReducer } from './NotificationBar/Reducer';
import { INotificationBarState } from './NotificationBar/Types';
import { ResetPasswordReducer } from './ResetPassword/Reducer';
import { ResetPasswordSaga } from './ResetPassword/Saga';
import { IResetPasswordState } from './ResetPassword/Types';
import { UpdatePasswordReducer } from './UpdatePassword/Reducer';
import { UpdatePasswordSaga } from './UpdatePassword/Saga';
import { IUpdatePasswordState } from './UpdatePassword/Types';
import { UserReducer } from './User/Reducer';
import { UserSaga } from './User/Sagas';
import { IUserState } from './User/Types';
import { UserManagementReducer } from './UserManagement/Reducer';
import { UserManagementSaga } from './UserManagement/Saga';
import { IUserManagementState } from './UserManagement/Types';
import { ResourcesManagementReducer } from './ResourcesManagement/Reducer';
import { ResourcesManagementSaga } from './ResourcesManagement/Saga';
import { IResourcesManagementState } from './ResourcesManagement/Types';

export interface IApplicationState {
	i18n: I18NState;
	layout: ILayoutState;
	notificationBar: INotificationBarState;
	router: RouterState;
	user: IUserState;
	resetPassword: IResetPasswordState;
	updatePassword: IUpdatePasswordState;
	userManagement: IUserManagementState;
	appsManagement: IAppsManagementState;
	resourcesManagement: IResourcesManagementState;
}

export interface IConnectedReduxProps<A extends Action = AnyAction> {
	dispatch: Dispatch<A>;
}

export const RootReducer = (history: History) =>
	combineReducers<IApplicationState>({
		i18n: I18NReducer,
		layout: LayoutReducer,
		notificationBar: NotificationBarReducer,
		router: connectRouter(history) as Reducer<
			RouterState,
			LocationChangeAction
		>,
		user: UserReducer,
		resetPassword: ResetPasswordReducer,
		updatePassword: UpdatePasswordReducer,
		userManagement: UserManagementReducer,
		appsManagement: AppsManagementReducer,
		resourcesManagement: ResourcesManagementReducer,
	});

export function* RootSaga() {
	yield effects.all([
		effects.fork(I18NSaga),
		effects.fork(LayoutSaga),
		effects.fork(UserSaga),
		effects.fork(ResetPasswordSaga),
		effects.fork(UpdatePasswordSaga),
		effects.fork(UserManagementSaga),
		effects.fork(AppsManagementSaga),
		effects.fork(ResourcesManagementSaga),
	]);
}
